import CryptoJS from 'crypto-js'

export function getDeviceId() {
  // 1. 先从本地取
  let deviceId = localStorage.getItem('device_id');

  if (!deviceId) {
    // 2. 构造浏览器基础信息（机器指纹）
    const canvas = getCanvasFingerprint(); // 画布指纹（防伪造）
    const agent = navigator.userAgent;
    const language = navigator.language;
    const platform = navigator.platform;
    const screen = `${window.screen.width}x${window.screen.height}`;

    // 3. 混合生成唯一 ID
    const raw = `${canvas}|${agent}|${language}|${platform}|${screen}|${Date.now()}`;
    deviceId = CryptoJS.MD5(raw).toString() // 32 位 hex，与 md5 一致

    // 4. 存入本地
    localStorage.setItem('device_id', deviceId);
  }

  return deviceId;
}

// 画布指纹（机器唯一，很难伪造）
function getCanvasFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.fillText('device-id-fingerprint', 10, 10);
    return canvas.toDataURL().slice(-20);
  } catch (e) {
    return 'no-canvas';
  }
}